var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpRequest, HttpRequestUrl } from '@bolteu/http-client';
var HttpRequestBoltServer = /** @class */ (function (_super) {
    __extends(HttpRequestBoltServer, _super);
    function HttpRequestBoltServer(baseUrl, request, opts) {
        var _this = _super.call(this, baseUrl, __assign(__assign({}, request), { path: request.service_id
                ? "/" + request.service_id + "/" + HttpRequestUrl.getNormalizedPath(request.path)
                : request.path }), opts) || this;
        _this.meta = request.meta;
        _this.serviceId = request.service_id;
        _this.subdomain = request.subdomain;
        return _this;
    }
    return HttpRequestBoltServer;
}(HttpRequest));
export { HttpRequestBoltServer };
